import type { CorrectionType } from "@/lib/store";
import { cn } from "@/lib/utils";
import { InfoIcon } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import { Word } from "./word";

const DefaultSpan = ({
  words,
  messageKey,
  isCorrection,
  className,
  isOnlySpan,
}: {
  words: string[];
  messageKey: string;
  className?: string;
  isCorrection?: boolean;
  isOnlySpan?: boolean;
}) => {
  return (
    <div
      className={cn(
        "text-xl flex flex-wrap",
        isCorrection ? "cursor-pointer" : "pb-1",
        className
      )}
    >
      {words.map((word, i) => {
        const wordKey = `${messageKey}-word-${i}`;
        return (
          <Word
            role="user"
            id={wordKey}
            key={wordKey}
            word={word}
            className={isOnlySpan ? "whitespace-pre-wrap" : ""}
          />
        );
      })}
    </div>
  );
};

const CorrectionSpan = ({
  words,
  messageKey,
  correction,
}: {
  words: string[];
  messageKey: string;
  correction: CorrectionType["items"][number];
}) => {
  return (
    <Tooltip>
      <div className="flex flex-col gap-1">
        <DefaultSpan
          isCorrection
          className="border-b-2 border-green-700 pb-1"
          words={words}
          messageKey={messageKey}
        />
        <span className="flex items-center gap-2">
          <DefaultSpan
            isCorrection
            className="text-green-700"
            words={[correction.correction]}
            messageKey={`${messageKey}-correction`}
          />
          <TooltipTrigger>
            <InfoIcon className="w-4 h-4 text-green-600" />
          </TooltipTrigger>
          <TooltipContent sideOffset={8}>
            <div className="text-white text-xl">{correction.explanation}</div>
          </TooltipContent>
        </span>
      </div>
    </Tooltip>
  );
};

export const WordSpan = ({
  words,
  messageKey,
  correction,
  isOnlySpan,
}: {
  words: string[];
  messageKey: string;
  correction?: CorrectionType["items"][number];
  isOnlySpan?: boolean;
}) => {
  if (correction) {
    return (
      <CorrectionSpan
        words={words}
        messageKey={messageKey}
        correction={correction}
      />
    );
  }
  return (
    <DefaultSpan
      isOnlySpan={isOnlySpan}
      words={words}
      messageKey={messageKey}
    />
  );
};
